export default "__VITE_ASSET__DpE549Oi__"